export const AnnouncementSource = {
  SEAP: "SEAP",
  OWN_WEBSITE: "Website propriu",
};

export const AnnouncementSourceOptions = Object.values(AnnouncementSource);
